import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
} from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useCloudProviderContext } from "../hooks/useCloudProviderContext"
import CloudBrowserContent from "./CloudBrowserContent"
import CloudBrowserImportOverlay from "./CloudBrowserImportOverlay"
import CloudBrowserTabBar from "./CloudBrowserTabBar"

interface Props {
  isOpen: boolean
  onClose: () => void
}

const CloudBrowserModalMobile: React.FC<Props> = ({ isOpen, onClose }) => {
  const { isImportingImages } = useCloudProviderContext()
  const { t } = useTranslation()

  return (
    <Drawer
      isOpen={isOpen}
      size="full"
      onClose={onClose}
      returnFocusOnClose={false}
      closeOnOverlayClick={!isImportingImages}
      closeOnEsc={!isImportingImages}
      placement="bottom"
    >
      <DrawerOverlay />
      <DrawerContent
        position="relative"
        overflow="hidden"
        maxHeight="100dvh"
        height="100dvh"
      >
        <DrawerHeader borderBottomWidth={1}>
          {t(
            "components.cloudProvider.common.CloudBrowserModalMobile.ImportPhotos"
          )}
        </DrawerHeader>
        <DrawerCloseButton />
        <DrawerBody px={0} py={0}>
          <Flex flexDirection="column" maxHeight="full" height="full">
            <CloudBrowserTabBar />
            <CloudBrowserContent isMobile={true} />
          </Flex>
        </DrawerBody>
        {isImportingImages && <CloudBrowserImportOverlay />}
      </DrawerContent>
    </Drawer>
  )
}

export default CloudBrowserModalMobile
